@if (issueDetailsForm) {
  <div class="grid-container">
    <form [formGroup]="issueDetailsForm">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-4">
          <label for="creationDateInput">*Creation Date:</label>
          <common-date-picker [id]="'creationDate'" [formGroup]="issueDetailsForm.get('creationDate')" [daysFuture]="2"></common-date-picker>
          @if (issueDetailsForm.controls['creationDate'].invalid && (issueDetailsForm.controls['creationDate'].dirty || issueDetailsForm.controls['creationDate'].touched)) {
            <div class="error-container">
              @if (issueDetailsForm.get('creationDate').hasError('required')) {
                <small class="error">
                  Creation Date is required
                </small>
              }
            </div>
          }
        </div>
        <div class="cell medium-4">
          <label for="dueDateInput">Due Date:</label>
          <common-date-picker [id]="'dueDateInput'" [formGroup]="issueDetailsForm.get('dateDue')" [daysFuture]="2"></common-date-picker>
        </div>
        <div class="cell medium-4">
          <label for="resolutionDateInput">Resolution Date:</label>
          <common-date-picker [id]="'resolutionDateInput'" [formGroup]="issueDetailsForm.get('resolutionDate')" [daysFuture]="2"></common-date-picker>
        </div>
        <div class="cell medium-4">
          <label for="issueOwnerInput">*Issue Owner:</label>
          <input type="text" id="issueOwnerInput" formControlName="issueOwner"
            placeholder="Issue Owner" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
            @if (issueDetailsForm.controls['issueOwner'].invalid && (issueDetailsForm.controls['issueOwner'].dirty || issueDetailsForm.controls['issueOwner'].touched)) {
              <div class="error-container">
                @if (issueDetailsForm.get('issueOwner').hasError('required')) {
                  <small class="error">
                    An Issue Owner is required
                  </small>
                }
              </div>
            }
          </div>
          <div class="cell medium-4">
            <label for="typeIdInput">*Issue Type:</label>
            <select id="typeIdInput" class="no-margin-bottom" formControlName="typeId" [attr.disabled]="'disabled'">
              @for (type of allIssueTypes; track type) {
                <option [value]="type.id">{{type.description}}</option>
              }
            </select>
            @if (issueDetailsForm.controls['typeId'].invalid && (issueDetailsForm.controls['typeId'].dirty || issueDetailsForm.controls['typeId'].touched)) {
              <div class="error-container">
                @if (issueDetailsForm.get('typeId').hasError('required')) {
                  <small class="error">
                    An Issue Type is required
                  </small>
                }
              </div>
            }
          </div>
          <div class="cell medium-4">
            <label for="legacyIdInput">Legacy Issue Number:</label>
            <input type="text" id="legacyIdInput" formControlName="legacyId"
              placeholder="N/A" [attr.disabled]="'disabled'" />
            </div>
            <div class="cell medium-6">
              <label for="organizationIdInput">Organization Number:</label>
              <input type="text" id="organizationIdInput" formControlName="organizationId"
                placeholder="Unknown" [attr.disabled]="'disabled'" />
              </div>
              <div class="cell medium-6">
                <label for="organizationNameInput">Organization Name at Time of Issue:</label>
                <input type="text" id="organizationNameInput" formControlName="organizationNameAtTimeOfIssue"
                  placeholder="Unknown" [attr.disabled]="'disabled'" />
                </div>
                <div class="cell medium-3">
                  <label for="inspectorIdInput">InspectorId</label>
                  <input type="text" id="inspectorIdInput" formControlName="inspectorId" a
                    placeholder="N/A" (blur)="onInspectorIdBlur($event)" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                  </div>
                  <div class="cell medium-3">
                    <label for="inspectionDateInput">Most Recent Inspection Date</label>
                    <common-date-picker [id]="'inspectionDateInput'" [formGroup]="issueDetailsForm.get('mostRecentInspectionDate')" [daysFuture]="2"></common-date-picker>
                  </div>
                  <!-- This Well section will need re-evaluted later, for phase one, no new issues types that are tied to wells will be created -->
                  <div class="cell medium-3">
                    <label for="wellIdInput">Well API Number</label>
                    <input type="text" id="wellIdInput" formControlName="wellId"
                      placeholder="N/A" [attr.disabled]="'disabled'" />
                    </div>
                    <div class="cell medium-3">
                      <label for="wellNameInput">Well Name</label>
                      <input type="text" id="wellNameInput" formControlName="wellNameAtTimeOfIssue"
                        placeholder="N/A" [attr.disabled]="'disabled'" />
                      </div>
                      <div class="cell medium-6">
                        <label for="holdIdInput">Chief's Order Number</label>
                        <input type="text" id="chiefsOrderId" formControlName="chiefsOrderId"
                          placeholder="N/A" [attr.disabled]="'disabled'" />
                        </div>
                        <div class="cell medium-6">
                          <label for="chiefsOrderValidatedInput" class="vertical-align-middle bold minor-margin-right">Chief's Order Validated</label>
                          <input class="no-margin-bottom vertical-align-middle" id="chiefsOrderValidatedInput" type="checkbox" formControlName="chiefsOrderValidated" [attr.disabled]="!chiefsOrderExists() ? 'disabled' : null">
                        </div>
                        <div class="cell medium-3">
                          <label for="chiefsOrderDueDateInput">Chief's Order Due Date</label>
                          <common-date-picker [id]="'chiefsOrderDueDateinput'" [formGroup]="issueDetailsForm.get('chiefsOrderDueDate')" [daysFuture]="2"></common-date-picker>
                        </div>
                        <div class="cell medium-3">
                          <label for="chiefsOrderCreationDateInput">Chief's Order Creation Date</label>
                          <common-date-picker [id]="'chiefsORderCreationDateInput'" [formGroup]="issueDetailsForm.get('chiefsORderCreationDate')" [daysFuture]="2"></common-date-picker>
                        </div>
                        <div class="cell medium-3">
                          <label for="chiefsOrderSignDateInput">Chief's Order Sign Date</label>
                          <common-date-picker [id]="'chiefsOrderSignDateInput'" [formGroup]="issueDetailsForm.get('chiefsOrderSignDate')" [daysFuture]="2"></common-date-picker>
                        </div>
                        <div class="cell medium-3">
                          <label for="chiefsOrderSentDateInput">Chief's Order Sent Date</label>
                          <common-date-picker [id]="'chiefsOrderSentDateInput'" [formGroup]="issueDetailsForm.get('chiefsOrderSentDate')" [daysFuture]="2"></common-date-picker>
                        </div>
                        <div class="cell medium-6">
                          <label for="holdIdInput">Hold Number</label>
                          <input type="text" id="holdIdInput" formControlName="holdId"
                            placeholder="N/A" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                          </div>
                          <div class="cell medium-6">
                            <label class="vertical-align-middle bold minor-margin-right" for="issueContestedInput">Is Issue Contested?</label>
                            <input class="no-margin-bottom vertical-align-middle" id="issueContestedInput" type="checkbox" formControlName="wasIssueContested"
                              (change)="contestedToggle($event.target.checked)" [attr.disabled]="isReadOnly() ? 'disabled' : null">
                            </div>
                            <div class="cell medium-6">
                              <h3>*Issue Description</h3>
                            </div>
                            <div class="cell medium-6">
                              <h3>Contested Reason</h3>
                            </div>
                            <div class="cell medium-6">
                              <textarea id="descriptionInput" [froalaEditor]="froalaDescriptionOptions" formControlName="description" placeholder="Enter Description"></textarea>
                              @if (issueDetailsForm.controls['description'].invalid && (issueDetailsForm.controls['description'].dirty || issueDetailsForm.controls['description'].touched)) {
                                <div class="error-container">
                                  @if (issueDetailsForm.get('description').hasError('required')) {
                                    <small class="error">
                                      Description is required
                                    </small>
                                  }
                                </div>
                              }
                            </div>
                            <div class="cell medium-6">
                              <textarea id="contestedReasonInput" [froalaEditor]="froalaContestedReasonOptions" formControlName="contestedReason" placeholder="Enter Reason for Contesting this Issue"></textarea>
                              @if (issueDetailsForm.controls['contestedReason'].invalid && (issueDetailsForm.controls['contestedReason'].dirty || issueDetailsForm.controls['contestedReason'].touched)) {
                                <div class="error-container">
                                  @if (issueDetailsForm.get('contestedReason').hasError('required')) {
                                    <small class="error">
                                      Reason is required if contested.
                                    </small>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </form>
                      </div>
                    }